module.exports = __webpack_public_path__ + "static/media/author_karthik_karuppaiah.fd149097.jpg";